import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { AuthService } from "../auth/auth.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AbortSignal } from 'abort-controller';
import { Pessoa } from "../model/pessoa";
import { MessageService } from 'primeng/api';


@Injectable()
export class PessoaService {

  private apiUrl = environment.api + environment.pessoa;

  constructor(protected authService:AuthService, protected http: HttpClient,
    private messageService: MessageService) { }

  public async getPessoa(chave: string): Promise<Pessoa> {
    const token = await this.authService.getAccessToken();

    const requestOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
    };

    try {
      const response = await this.http
        .get<Pessoa>(this.apiUrl + chave,  requestOptions)
        .toPromise();
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Requisição abortada');
      } else {
        this.messageService.add({ severity: 'error',  summary: error.error.title, detail: error.error.detail  });
        throw error;
      }
      throw error;
    }
  }
}